import React from 'react';
import { useLocale } from 'locale';
import { Route } from 'config/routes';
import { DealType, IBulletin, IProject, MarketplaceType } from 'utils/entities';
import styled from '@emotion/styled';
import { H3 } from 'ds/components/typography';
import { ZoneLink } from 'ds/components/link/styled';
import ProjectCarousel from 'components/project-carousel';
import { Seller } from 'components/filters/types';
import ArrowLinkIcon from 'assets/svg/link-arrow.svg';
import { connect } from 'react-redux';
import { poiSearchProjectListSelector } from 'store/state/domainData/selectors';
import { State } from 'store/state';
import { marketplaceSelector } from 'store/state/selectors/router';
import { SpacingBlock } from 'components/spacing-block';


const Root = styled.div``;

const Header = styled.div`
  ${({ theme }) => `
    display: flex;
    justify-content: space-between;
    margin-bottom: ${theme.spacing(3)};
  `}
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    margin-bottom: ${theme.spacing(2)};
    flex-direction: column;
  `}
`;

const Title = styled(H3.withComponent('h2'))``;

interface ProjectsSectionProps {
  term: string;
  zoneName?: string;
  type?: string;
  dealType?: DealType;
  areaCityName?: string;
  areaNeighbourhoodName?: string;
  projects: Array<IBulletin | IProject>;
  marketplace: MarketplaceType;
}

const NearbyProjectsSection: React.FC<ProjectsSectionProps> = props => {
  const { term, zoneName, type, dealType, areaCityName = null, areaNeighbourhoodName = null, projects, marketplace } = props;
  const { t } = useLocale();

  if (!projects || projects.length === 0) return null;

  const isCommercial = marketplace === MarketplaceType.Commercial;

  return (
    <Root data-auto="projects-for-sale">
      <Header>
        <Title weight="bold">{t('nearbyProjectsSection.title', { type, areaName: areaCityName || areaNeighbourhoodName, dealType })}</Title>
        <SpacingBlock mTop={0.5} />
        <ZoneLink
          data-auto="all-city-nghb-projects"
          preserveParams
          routeName={isCommercial ? Route.SearchCommercial : Route.Search}
          hideLinkParams
          routeParams={{
            term: [ term ],
            dealType,
            filters: {
              seller: [ Seller.Developer ],
            },
          }}
        >
          {t('nearbyProjectsSection.seeMore', { type, zoneName })}
          <ArrowLinkIcon />
        </ZoneLink>
      </Header>
      <ProjectCarousel />
    </Root>
  );
};
NearbyProjectsSection.defaultProps = {
  type: null,
  dealType: DealType.Buy,
};

const mapStateToProps = (state: State) => ({
  projects: poiSearchProjectListSelector(state),
  marketplace: marketplaceSelector(state),
});

export default connect(mapStateToProps)(NearbyProjectsSection);

